import React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";
import { cn } from "@/lib/utils";

interface SkillToggleProps extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> {
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
  disabled?: boolean;
}

const SkillToggle: React.FC<SkillToggleProps> = ({ 
  enabled, 
  onToggle, 
  disabled = false,
  className,
  ...props 
}) => {
  return (
    <SwitchPrimitives.Root
      checked={enabled}
      onCheckedChange={onToggle}
      disabled={disabled}
      className={cn(
        "relative inline-flex h-7 w-14 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        enabled ? "bg-[rgb(236,178,45)]" : "bg-gray-300",
        className
      )}
      {...props}
    >
      <SwitchPrimitives.Thumb
        className={cn(
          "pointer-events-none block h-6 w-6 rounded-full bg-white shadow-lg ring-0 transition-transform",
          enabled ? "translate-x-7" : "translate-x-0"
        )}
      />
    </SwitchPrimitives.Root>
  );
};

export default SkillToggle; 